export default function Home() {
    return <div id="home"></div>
}